import React from "react"
import classNames from "classnames"
import { Link } from "react-router-dom"
import { DatePicker, DateRangePicker } from "rsuite"
import enUS from "rsuite/locales/en_US"

const sundayFirstLocale = {
  ...enUS,
  Calendar: {
    ...enUS.Calendar,
    firstDayOfWeek: 0, // 0 = Sunday, 1 = Monday
  },
}

const CommonDateFilter = ({
  isLoading,
  date,
  commonDateRange,
  setCommonDateRange,
  formattedToday,
  formattedStartOfCurrentWeek,
  formattedEndOfCurrentWeek,
  formattedStartOfMonth,
  formattedEndOfMonth,
  formattedYesterday,
  formatDate,
  commonDayType,
  setCommonDayType,
  t,
}) => {
  const onChangeChartPeriod = type => {
    setCommonDayType(type)
    if (type === "day") {
      setCommonDateRange({
        start: formattedToday,
        end: formattedToday,
      })
    } else if (type === "week") {
      setCommonDateRange({
        start: formattedStartOfCurrentWeek,
        end: formattedEndOfCurrentWeek,
      })
    } else if (type === "month") {
      setCommonDateRange({
        start: formattedStartOfMonth,
        end: formattedEndOfMonth,
      })
    } else if (type === "custom") {
      setCommonDateRange({
        start: formattedYesterday,
        end: formattedToday,
      })
    }
  }

  const handleOnDateChange = (selectedDates, type) => {
    const formattedDate = `${selectedDates.getFullYear()}-${(
      selectedDates.getMonth() + 1
    )
      .toString()
      .padStart(2, "0")}-${selectedDates.getDate().toString().padStart(2, "0")}`

    if (type === "day") {
      setCommonDateRange({
        start: formattedDate,
        end: formattedDate,
      })
    }
  }

  const handleDateRangeChange = value => {
    setCommonDateRange({
      start: formatDate(value[0]),
      end: formatDate(value[1]),
    })
  }

  //   useEffect(() => {
  //     console.log(commonDateRange)
  //   }, [commonDateRange])

  return (
    <ul className="nav nav-pills" style={{ minWidth: 540 }}>
      <li className="nav-item">
        <Link
          to="#"
          className={classNames(
            { active: commonDayType === "day" },
            { "disabled-link": isLoading },
            "nav-link"
          )}
          onClick={() => {
            !isLoading && onChangeChartPeriod("day")
          }}
          id="one_month"
        >
          {t("Day")}
        </Link>{" "}
      </li>
      <li className="nav-item">
        <Link
          to="#"
          className={classNames(
            { active: commonDayType === "week" },
            { "disabled-link": isLoading },
            "nav-link"
          )}
          onClick={() => {
            !isLoading && onChangeChartPeriod("week")
          }}
        >
          {t("Week")}
        </Link>{" "}
      </li>
      <li className="nav-item">
        <Link
          to="#"
          className={classNames(
            { active: commonDayType === "month" },
            { "disabled-link": isLoading },
            "nav-link"
          )}
          onClick={() => {
            !isLoading && onChangeChartPeriod("month")
          }}
        >
          {t("Month")}
        </Link>{" "}
      </li>
      <li className="nav-item">
        <Link
          to="#"
          className={classNames(
            { active: commonDayType === "custom" },
            { "disabled-link": isLoading },
            "nav-link"
          )}
          onClick={() => {
            !isLoading && onChangeChartPeriod("custom")
          }}
        >
          {t("Custom")}
        </Link>{" "}
      </li>
      {/* SHOW */}

      <li style={{ maxWidth: 115, marginLeft: 5 }}>
        {commonDayType === "day" && (
          <DatePicker
            format="yyyy-MM-dd"
            locale={sundayFirstLocale}
            defaultValue={new Date(date)}
            onChange={value => handleOnDateChange(value, "day")}
          />
        )}
      </li>

      <li style={{ maxWidth: 210, marginLeft: 10 }}>
        {commonDayType === "week" && (
          <DateRangePicker
            format="yyyy-MM-dd"
            defaultValue={[
              new Date(commonDateRange.start),
              new Date(commonDateRange.end),
            ]}
            hoverRange="week"
            ranges={[]}
            oneTap
            locale={sundayFirstLocale}
            // isoWeek
            onChange={handleDateRangeChange}
          />
        )}
      </li>
      <li style={{ maxWidth: 210, marginLeft: 10 }}>
        {commonDayType === "month" && (
          <DateRangePicker
            format="yyyy-MM-dd"
            defaultValue={[
              new Date(formattedStartOfMonth),
              new Date(formattedEndOfMonth),
            ]}
            hoverRange="month"
            ranges={[]}
            oneTap
            locale={sundayFirstLocale}
            // isoWeek
            onChange={handleDateRangeChange}
          />
        )}
      </li>

      <li style={{ maxWidth: 200, marginLeft: 5 }}>
        {commonDayType === "custom" && (
          <DateRangePicker
            format="yyyy-MM-dd"
            defaultValue={[
              new Date(formattedYesterday),
              new Date(formattedToday),
            ]}
            locale={sundayFirstLocale}
            ranges={[]}
            onChange={handleDateRangeChange}
          />
        )}
      </li>
    </ul>
  )
}

export default CommonDateFilter
